import { Injectable } from '@angular/core'
import { ConfigService } from "src/app/shared/utils/config.service";
import { ClientService } from 'src/app/shared/services/client.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { AppenateService } from 'src/app/shared/services/appenate.service';
import { PasswordValidationModel, EmailValidationModel, WebSiteUrlValidationModel, UserNameValidationModel } from 'src/app/shared/models/common-validation.model';
import { GridFilterModel } from 'src/app/shared/models/grid-filter.model';
import { async } from '@angular/core/testing';
import { AppenateCreateUserModel, AppenateDeleteUserModel } from './shared/models/appenate-createuser.model';
import { NotificationModel } from './shared/models/notification.model';
import { EmployeeSetupService } from 'src/app/shared/services/employee-setup.service';

const urlRegex = require('url-regex');

@Injectable()
export class AppCode {
  client: any = {};
  model: any = { email: "", userName: "", firstName: "", lastName: "", passWord: "", IsActive: true, ClientId: 0, roles: [] };
  passwordValidationModel: PasswordValidationModel = new PasswordValidationModel();
  emailValidationModel: EmailValidationModel = new EmailValidationModel();
  webSiteUrlValidationModel: WebSiteUrlValidationModel = new WebSiteUrlValidationModel();
  userNameValidationModel: UserNameValidationModel = new UserNameValidationModel();
  gridFilterModel: GridFilterModel = new GridFilterModel();
  currentRoute: string;
  environmentName: string = "";
  baseAzureDownLoadUrl: string = '';
  firstMenuUrl: string = '';
  constructor(private clientService: ClientService, private authService: AuthService, private appenateService: AppenateService
    , private config: ConfigService, private employeeSetupService: EmployeeSetupService) {
    this.client = this.clientService.getClient();
    this.environmentName = this.config.environmentName;
    this.baseAzureDownLoadUrl = this.config.getBaseApiURI();
  }

  setPageHeight() {
    if (document.getElementById('panelGrid') != null) {
      var pageHeight = ((document.getElementById('panelGrid').clientHeight * 2) + 60) + "px";
      if (document.getElementById('parentPageContent') != null) {
        document.getElementById('parentPageContent').setAttribute("style", "min-height:" + pageHeight);
      }
    }
  }

  getSiteUrl() {
    var url = window.location.origin + "/";
    return url;
  }

  // Password Pattern & Validation Process
  onPasswordValidation(password: string, isRequired: boolean) {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    var mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");

    if (password == "" && isRequired) {
      this.passwordValidationModel.isPasswordValid = false;
      this.passwordValidationModel.passwordStrength["background-color"] = "white";
      this.passwordValidationModel.validationMessage = "Password is required";
    }
    else if (strongRegex.test(password)) {
      this.passwordValidationModel.isPasswordValid = true;
      this.passwordValidationModel.passwordStrength["background-color"] = "green";
      this.passwordValidationModel.validationMessage = "";
    }
    else if (mediumRegex.test(password)) {
      this.passwordValidationModel.isPasswordValid = false;
      this.passwordValidationModel.passwordStrength["background-color"] = "orange";
      this.passwordValidationModel.validationMessage = this.passwordValidationModel.passwordCriteria;
    }
    else {
      this.passwordValidationModel.isPasswordValid = false;
      this.passwordValidationModel.passwordStrength["background-color"] = "red";
      this.passwordValidationModel.validationMessage = this.passwordValidationModel.passwordCriteria;
    }

    return this.passwordValidationModel;
  }

  // Email Pattern & Validation Process
  onEmailValidation(newValue: string, isRequired: boolean) {
    const validEmailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.emailValidationModel.isEmailRequired = isRequired;
    if (isRequired == true && newValue == "") {
      this.emailValidationModel.isEmailIdValid = false;
      this.emailValidationModel.validationMessage = "Email Id is required.";
      return this.emailValidationModel;
    }
    else if (isRequired == false && newValue == "") {
      this.emailValidationModel.isEmailIdValid = true;
      this.emailValidationModel.validationMessage = "";
      return this.emailValidationModel;
    }
    else if (validEmailRegEx.test(newValue)) {
      this.emailValidationModel.isEmailIdValid = true;
      this.emailValidationModel.validationMessage = "";
      return this.emailValidationModel;
    }
    else {
      this.emailValidationModel.isEmailIdValid = false;
      this.emailValidationModel.validationMessage = "Invalid Email Id";
      return this.emailValidationModel;
    }
  }

  // Avoid Special Character
  omit_special_char(event) {
    var k;
    var val;
    k = event.charCode;
    if (((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 58)) || (k == 45)) {
      val = true;
    }
    else {
      val = false;
    }
    return val;
  }

  // Only Number Allowed
  numberOnly(event: any) {
    const pattern = /[0-9\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  // Only Character Allowed
  charOnly(event: any) {
    const pattern = /[A-Z a-z\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  // Only Number and Decimal Allowed
  allowOnlyNumberAndDecimals(event: any) {
    let str = event.target.value;
    const regExp = /^(\d+(\.\d+)?)$/;
    let status = regExp.test(str) ? 'valid' : 'invalid';
    console.log("allowOnlyNumberAndDecimals -> status ->   " + status);
  }

  // Scroll To - Panel
  scrollTo(panelId: string) {
    if (document.getElementById(panelId)) { 
      document.getElementById(panelId).scrollIntoView({ behavior: "smooth" });
    }
  }

  //async getRoles(roleNames:any) {
  getRoles = async (roleNames: any): Promise<any> => {
    var rolesList: any = [];
    const response = await this.authService.getRoles().toPromise();
    var roleData = JSON.parse(JSON.stringify(response));
    if (roleData) {
      //roleNames[0].toLowerCase()
      for (var i = 0; i < roleNames.length; i++) {
        var roleRec = roleData.find(f => f.name.toLowerCase() == roleNames[i].toLowerCase());
        if (roleRec) {
          let reqRole = { Id: roleRec.id, Name: roleRec.name, ConcurrencyStamp: roleRec.concurrencyStamp };
          rolesList.push(reqRole);
        }
      }
    }
    return await rolesList;
  }

  //emailFor should be 'web/mobile/webmobile'
  async createUser(userData: any, roles: any, sendNotification: boolean) {
    this.client = this.clientService.getClient();
    this.model.email = userData.userName;
    this.model.userName = userData.email;
    this.model.firstName = userData.firstName;
    this.model.lastName = userData.lastName;
    this.model.passWord = userData.password;
    this.model.IsActive = userData.IsActive;
    this.model.ClientId = this.client.clientId;
    this.model.roles = [];
    this.model.roles = await this.getRoles(roles);
    this.model.sendNotification = sendNotification;
    this.model.isActive = userData.isActive != undefined ? userData.isActive : true;

    var siteUrl = this.authService.getSiteUrl();
    if (siteUrl.indexOf('localhost') > -1) {
      this.model.clientId = this.config.testClientId;
    }

    //authService.register() method includes email Notification to newly created user and respective Admin - based on client table configuration
    var result = await this.authService.register(this.model).toPromise();
    var result = JSON.parse(JSON.stringify(result));

    return result.id;
  }

  async createAppenateUser(userData: AppenateCreateUserModel) {
    var result = await this.appenateService.createuser(userData);
    return result;
  }

  async updateAppenateUser(userData: AppenateCreateUserModel) {
    var result = await this.appenateService.updateUser(userData);
    return result;
  }

  //check is exist user on appenate
  //async isExistAppenateUser(CompanyId, IntegrationKey, Email) {
  //  var result = await this.appenateService.isExistAppenateUser(CompanyId, IntegrationKey, Email);
  //  return result;
  //}
  async checkUserNameExistsInAppenate(CompanyId, IntegrationKey, Email) {
    var result = await this.appenateService.isExistAppenateUser(CompanyId, IntegrationKey, Email);
    if (result != null && result != undefined && result == 1) {
      this.userNameValidationModel.isValid = false;
      this.userNameValidationModel.validationMessage = "This username is taken for Mobile App. Try another.";
    }
    return this.userNameValidationModel;
  }

  // Delete user from Appenate
  async deleteAppenateUser(userDeleteData: AppenateDeleteUserModel) {
    var result = await this.appenateService.deleteUser(userDeleteData);
    return result;
  }

  async sendVerificationEmailToUserAndAdmin(notificationModel: NotificationModel) {
    notificationModel.siteUrl = this.authService.getSiteUrl();
    if (notificationModel.siteUrl.indexOf('localhost') > -1) {
      notificationModel.clientId = this.config.testClientId;
    }
    var result = await (await this.authService.sendVerificationEmailToUserAndAdmin(notificationModel)).toPromise();
    return result;
  }

  getGridFilterConditionForSQL(filterData: any) {
    var whereCondition = "";
    var c = 1;
    if (filterData != undefined) {
      for (var j = 0; j < filterData.length; j++) {
        for (var f = 0; f < filterData[j].filters.length; f++) {
          whereCondition += f > 0 ? " " + filterData[j].logic + " " : " ";
          var operator = filterData[j].filters[f].operator;
          var value = filterData[j].filters[f].value;
          value = value.replace("'", "''");
          var condition = "";
          if (operator == "eq") {
            condition = " = '" + value + "' ";
          }
          if (operator == "neq") {
            condition = " != '" + value + "' ";
          }
          if (operator == "startswith" || operator == "sw") {
            condition = " Like '" + value + "%' ";
          }
          if (operator == "contains" || operator == "c") {
            condition = " Like '%" + value + "%' ";
          }
          if (operator == "doesnotcontain" || operator == "dnc") {
            condition = " Not Like '%" + value + "%' ";
          }
          if (operator == "endswith" || operator == "ew") {
            condition = " Like '%" + value + "' ";
          }
          if (operator == "gte") {
            if (Date.parse(value)) {
              condition = " >= '" + value + "' ";
            }
            else {
              condition = " >= " + value + " ";
            }

          }
          if (operator == "gt") {
            if (Date.parse(value)) {
              condition = " > '" + value + "' ";
            }
            else {
              condition = " > " + value + " ";
            }
          }
          if (operator == "lte") {
            if (Date.parse(value)) {
              condition = " <= '" + value + "' ";
            }
            else {
              condition = " <= " + value + " ";
            }
          }
          if (operator == "lt") {
            if (Date.parse(value)) {
              condition = " < '" + value + "' ";
            }
            else {
              condition = " < " + value + " ";
            }
          }
          if (operator == "isnotnull") {
            condition = " is not null  ";
          }
          if (operator == "isnull") {
            condition = " is null ";
          }
          if (operator == "isempty" || operator == "ie") {
            condition = " = '' ";
          }
          if (operator == "isnotempty") {
            condition = " != '' ";
          }
          whereCondition += filterData[j].filters[f].field + condition;
        }
        if (filterData.length > c) {
          whereCondition = "(" + whereCondition + ")";
          whereCondition += " and ";
        }
        c++;
      }
    }
    
    return whereCondition;
  }

  async deactivateUser(userId: string) {
    var userData = await this.authService.getUserFromDatabase(userId).toPromise();
    if (userData != null && userData.IsActive) {
      var result = await this.authService.deactivateUser(userId).toPromise();
      result = JSON.parse(JSON.stringify(result));
      return result;
    }
  }

  async reactivateUser(userId: string) {
    var userData = await this.authService.getUserFromDatabase(userId).toPromise();
    if (userData != null && !userData.IsActive) {
      var result = await this.authService.reactivateUser(userId).toPromise();
      result = JSON.parse(JSON.stringify(result));
      return result;
    }
  }

  getGridSortConditionForSQL(sortData: any) {
    var sortingStr = "";
    if (sortData != null) {
      if (sortData.length != 0) {
        for (let i = 0; i < sortData.length; i++) {
          if (sortData[i].dir != undefined) {
            if (sortingStr != "") sortingStr += ",";
            sortingStr += sortData[i].field + " " + sortData[i].dir;
          }
        }
      }
    }
    return sortingStr;
  }

  onWebsiteUrlValidation(webSiteName: string, isRequired: boolean) {
    this.webSiteUrlValidationModel.isValid = true;
    this.webSiteUrlValidationModel.validationMessage = "";

    if (isRequired && webSiteName == "") {
      this.webSiteUrlValidationModel.isValid = false;
      this.webSiteUrlValidationModel.validationMessage = "Website Url is required.";
    }
    else if (!isRequired && webSiteName == "") {
      this.webSiteUrlValidationModel.isValid = true;
      this.webSiteUrlValidationModel.validationMessage = "";
    }
    else if (!urlRegex({ exact: true, strict: false }).test(webSiteName)) {
      this.webSiteUrlValidationModel.isValid = false;
      this.webSiteUrlValidationModel.validationMessage = "Enter valid Website Url";
    }
    return this.webSiteUrlValidationModel;
  }

  async checkUserNameExists(userName: string, userId: string) {
    debugger;
    var result = await this.authService.getUserByUserName(userName).toPromise();
    if (result != null && result != undefined) {
      var user = await JSON.parse(JSON.stringify(result));
      if (user) {
        if (user.Message != undefined && user.Message == "UserNotFound") {
          this.userNameValidationModel.isValid = true;
          this.userNameValidationModel.validationMessage = "";
          return await this.userNameValidationModel;
        }
        else if (user.UserId != userId) {
          this.userNameValidationModel.isValid = false;
          this.userNameValidationModel.validationMessage = "This username is taken. Try another.";
        }
      }
    }
    return this.userNameValidationModel;

    //this.authService.getUserByUserName(userName).subscribe(async(data) => {
    //  var user = await JSON.parse(JSON.stringify(data));
    //  if (user) {
    //    if (user.Message != undefined && user.Message == "UserNotFound") {
    //      this.userNameValidationModel.isValid = true;
    //      this.userNameValidationModel.validationMessage = "";
    //      return await this.userNameValidationModel;
    //    }
    //    else if (user.UserId != userId) {
    //      this.userNameValidationModel.isValid = false;
    //      this.userNameValidationModel.validationMessage = "That username is taken. Try another.";         
    //    }
    //  }
    //});
    //return this.userNameValidationModel;
  }

  //this method to get defualt filter parameters for Grid-server side pagination. 
  getGridFilterModel() {
    var userData = JSON.parse(localStorage.getItem("currentUser"));
    var clientData = JSON.parse(localStorage.getItem("currentClient"));
    this.gridFilterModel = new GridFilterModel();
    this.gridFilterModel.clientId = clientData.clientId;
    this.gridFilterModel.clientCode = clientData.clientCode;
    this.gridFilterModel.isAdmin = false;
    this.gridFilterModel.userRoles = localStorage.getItem("Roles");
    this.gridFilterModel.userId = userData.user.UserName;
    this.gridFilterModel.userEmail = userData.user.UserName;

    return this.gridFilterModel;
  }

  async getCurrentClientData() {
    this.client = await this.clientService.getClient();
    return this.client;
  }
  async getCurrentClientId() {
    this.client = await this.clientService.getClient();
    return this.client.clientId;
  }
  async getCurrentClientCode() {
    this.client = await this.clientService.getClient();
    return this.client.clientCode;
  }

  getCurrentUserName() {
    return localStorage.getItem('Username');
  }

  getCurrentUserData() {
    return JSON.parse(localStorage.getItem('currentUser'));
  }

  getCurrentUserRoles() {
    return localStorage.getItem("Roles");
  }

  getCurrentUserId() {
    var data = JSON.parse(localStorage.getItem('currentUser'));
    return data.id;
  }

  getGlobalFilterConfiguration() {
    var data = JSON.parse(localStorage.getItem('globalFilterConfigData'));
    return data;;
  }

  async getGlobalFilterCondition() {
    var filterConfigData = await JSON.parse(localStorage.getItem('globalFilterConfigData'));
    var filterString = "";
    if (filterConfigData != undefined && filterConfigData != null) {
      for (var d = 0; d < filterConfigData.length; d++) {
        var localStorageGetItem = localStorage.getItem(filterConfigData[d].localStorageName);
        if (localStorageGetItem != null && localStorageGetItem != undefined && localStorageGetItem != '0') {
          if (filterString != "") filterString += "|";
          filterString += filterConfigData[d].localStorageName + "=" + localStorage.getItem(filterConfigData[d].localStorageName);
        }
      }
    }
    return await filterString;;
  }

  async getGlobalFilterTextCondition() {
    var filterConfigData = await JSON.parse(localStorage.getItem('globalFilterConfigData'));
    var filterString = "";
    if (filterConfigData != undefined && filterConfigData != null) {
      for (var d = 0; d < filterConfigData.length; d++) {
        var localStorageGetItem = localStorage.getItem(filterConfigData[d].localStorageName + "_Text");
        if (localStorageGetItem != null && localStorageGetItem != undefined && localStorageGetItem != '0') {
          if (filterString != "") filterString += "|";
          filterString += filterConfigData[d].localStorageName + "=" + localStorage.getItem(filterConfigData[d].localStorageName + "_Text");
        }
      }
    }
    return await filterString;;
  }

  sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  validateFormatedText(val: string, format: string) {
    var formatedText = "";
    var valUsedIndex = 0;
    for (var i = 0; i < (val.length < format.length ? val.length : format.length); i++) {
      if (format.charAt(i) == "#") {
        formatedText += val.charAt(valUsedIndex);
        valUsedIndex++;
      }
      else if (formatedText.length < format.length) {
        if (format.charAt(i) != val.charAt(valUsedIndex)) {
          formatedText += format.charAt(i);
        }
        formatedText += val.charAt(valUsedIndex);
        valUsedIndex++;
      }
    }
    return formatedText;
  }

  async getCurrentUserEmployeeId() {
    if (localStorage.getItem('employeeId') != null && localStorage.getItem('employeeId') != undefined) {
      return parseInt(localStorage.getItem('employeeId'));
    }
    else {
      var userId = await this.getCurrentUserId();
      var data = await this.employeeSetupService.getEmployeeByUserID(userId);
      if (data != undefined && data != null) {
        var tblEmployeeId = data[0].tblEmployeeId
        localStorage.setItem('employeeId', tblEmployeeId);
        return parseInt(tblEmployeeId);
      }
    }
  }

  getAzureDownloadUrl(clientId: string, fileName: string, serverFolderName: string) {
    var url = this.config.getEmportalAPIUrl() + '/api/AzureStorage/DownloadFileV2?';
    url = url + 'fileName=' + fileName + '&ClientId=' + clientId + '&ServerFolderName=' + serverFolderName;
    return url;
  }

  async checkUrlAccess(currentUrl: string) {
    var returnBool = false;
    var user = await this.getCurrentUserData();
    var client = await this.getCurrentClientData();

    var menus = client.clientSetting.navigationSetting.menus;
    if ((user.IsUserSystemAdmin != null && user.IsUserSystemAdmin) || (user.IsUserClientAdmin != null && user.IsUserClientAdmin))
      return true;

    for (var i = 0; i < menus.length; i++) {
      var menu = menus[i];
      if (returnBool == false) {
        if (menu != null && menu.url != null) {
          returnBool = await this.checkEachMenuAccess(menu, currentUrl, user);
          if (returnBool == true) break;
        }
        else if (menu != null && menu.url == null) {
          for (var s = 0; s < menu.subMenus.length; s++) {
            returnBool = await this.checkEachMenuAccess(menu.subMenus[s], currentUrl, user);
            if (returnBool == true) break;
          }
        }
      }
      else {
        return returnBool;
      }
    }
    return returnBool;
  }

  async checkEachMenuAccess(menu: any, currentUrl: string, user: any) {
    var result = false;
    if (menu != null && menu.url != null && menu.url.toLowerCase() == currentUrl.toLowerCase()) {
      if (menu != null && menu.roles != null && menu.roles.length > 0) {
        menu.roles.forEach(
          role => {
            var index = user.roles.indexOf(role.role);
            if (index > -1) {
              result = true;
              return result;
            }
          }
        );
      }
    }
    else if (menu != null && menu.url != null && this.firstMenuUrl == "") {
      if (menu != null && menu.roles != null && menu.roles.length > 0) {
        menu.roles.forEach(
          role => {
            var index = user.roles.indexOf(role.role);
            if (index > -1) {
              this.firstMenuUrl = menu.url;
            }
          }
        );
      }
    }
    return result;
  }



}
